import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/components/Landing'
import Select from '@/components/Select'
import Intro from '@/components/Intro'
import Game from '@/components/Game'
import Congrats from '@/components/Congrats'
import TimesUp from '@/components/TimesUp'
import Incorrect from '@/components/Incorrect'
import Leaderboard from '@/components/Leaderboard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/select',
      name: 'Select',
      component: Select
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/game',
      name: 'Game',
      component: Game
    },
    {
      path: '/congrats',
      name: 'Congrats',
      component: Congrats
    },
    {
      path: '/timesup',
      name: 'TimesUp',
      component: TimesUp
    },
    {
      path: '/incorrect',
      name: 'Incorrect',
      component: Incorrect
    },
    {
      path: '/leaderboard',
      name: 'Leaderboard',
      component: Leaderboard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js